import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import { useLogoutMutation } from '../features/auth/api/authApi';
import Toast from './ToastNotification';
import { useSocket } from '../contexts/SocketContext';
import { API_DOCS_URL } from '../utils/contants';

const Sidebar = () => {
    const navigate = useNavigate();
    const socket = useSocket();
    const [logoutApi] = useLogoutMutation();

    const handleLogout = async () => {
        try {
            const logoutResponse = await logoutApi().unwrap();
            if (logoutResponse.success) {
                if (socket && socket.connect) {
                    socket.disconnect()
                }

                Toast.success('User Logout Successfully');
                navigate('/login', { replace: true });
            }
        } catch (error) {
            Toast.error(error.message || error?.data?.message || 'An error occurred while connecting');
        }
    }

    return (
        <div className="dashboard-container">
            <aside className="sidebar">
                <h3 style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>Chat App</h3>
                <nav>
                    <NavLink to="employee" className="nav-link">Employee</NavLink>
                    <NavLink to="setting" className="nav-link">Settings</NavLink>
                    <NavLink to="api-credentials" className="nav-link">API Management</NavLink>
                    <a
                        href={API_DOCS_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="nav-link"
                    >
                        API Docs
                    </a>
                    <NavLink to="business-hour" className="nav-link">Business Hour</NavLink>
                    <NavLink to="bulk-upload" className="nav-link">Bulk Message Upload</NavLink>
                    <NavLink to="change-password" className="nav-link">Change Password</NavLink>
                </nav>
                <button onClick={handleLogout} className="logout-btn">Logout</button>
            </aside>
        </div>
    )
}

export default Sidebar;
